import Compressor from "compressorjs";
import { isIOS, isSafari } from "react-device-detect";
import { getSafariVersion } from "@util/common";

const zipFile = (file: any, quality: number) =>
  new Promise((resolve, reject) => {
    try {
      new Compressor(file, {
        quality: quality,
        width: 700,
        success(resResult: any) {
          resolve(resResult);
        },
        error(err) {
          reject(err);
        }
      });
    } catch (e) {
      /* ... */
    }
  });
const factorial = (size: number, file: Blob, quality: number) =>
  new Promise((resolve, reject) => {
    quality = Number((quality - 0.1).toFixed(1));
    zipFile(file, quality)
      .then((zipRes: any) => {
        if (zipRes.size / 1048576 > 2 && quality >= 0) {
          factorial(zipRes.size, zipRes, quality)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        } else {
          resolve(zipRes);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
const imageOnLoad = (imgFile: File) =>
  new Promise((resolve, reject) => {
    // Be careful to use 1 as it may make the size of the output image become larger.
    // Link https://github.com/fengyuanchen/compressorjs#options
    const quality = 0.9;
    const safariVersion = getSafariVersion();
    const maxSize =
      isIOS && isSafari && safariVersion && safariVersion <= 12
        ? 1 * 1024 * 1024
        : 2 * 1024 * 1024;
    let imagePayload = {
      image: imgFile
    };
    if (imgFile.size > maxSize) {
      factorial((imgFile.size / 1024) * 1024, imgFile, quality)
        .then((res: any) => {
          imagePayload = {
            image: res
          };
          resolve(imagePayload);
        })
        .catch((err) => {
          reject(err);
          window.console.log(err);
        });
    } else {
      resolve(imagePayload);
    }
  });

export default imageOnLoad;
